<!--
  洽谈右键

  布局右键菜单，编写样式
  将右键菜单需要的用到的数据在vuex中进行定义
  全局注册一个指令，命名为rightClick
  拦截被绑定元素的oncontextmenu事件，对组件传过来的值进行处理
  更新vuex里的右键菜单数据，触发右键菜单显示
 -->

<template>
  <div
    id="rightMenuDom"
    class="right-menu"
    :style="{
      display: rightMenuStatus,
      top: rightMenuTop,
      left: rightMenuLeft,
    }"
  >
    <!-- <p @click="handleTranslate">
      <img src="https://oss-resource668.yzdli.com/website/image/icon/icon_translate.png?v=2" alt="翻译"
           class="icon_translate">
      <img src="https://oss-resource668.yzdli.com/website/image/icon/icon_translate_hover.png?v=2" alt="翻译"
           class="icon_translate_hover">

      <span v-if="$store.state.locale === 'zh'">翻译成中文</span>
      <span v-else>Translate into English</span>
    </p> -->
    <p @click="handleCopy">
      <a-icon type="copy" />
      <span>{{ $t('复制') }}</span>
    </p>
    <!-- <p @click="handleDel">
      <a-icon type="delete" /> <span>删除</span>
    </p> -->
    <p v-if="retractMsgId && rightMenu.originalInfo.id === retractMsgId" @click="handleWithdraw">
      <a-icon type="rollback" />
      <span>{{ $t('撤回') }}</span>
    </p>
  </div>
</template>
<script>
import throttle from 'lodash/throttle'

import { mapState } from 'vuex'
import { transform } from '@/api/pushSend'
import { copyText } from '~/utils/util'

export default {
  computed: {
    ...mapState({
      rightMenu: (state) => state.chat.rightMenu,
    }),
    // 右键菜单显隐状态
    rightMenuStatus() {
      return this.rightMenu.status
    },
    // 右键菜单距离浏览器顶部高度
    rightMenuTop() {
      return this.rightMenu.top
    },
    // 右键菜单距离浏览器左边长度
    rightMenuLeft() {
      return this.rightMenu.left
    },
    retractMsgId() {
      return this.rightMenu.retractMsgId
    },
  },
  mounted() {
    window.addEventListener('click', () => {
      this.hiddenRightMenu()
    })
  },
  beforeDestroy() {
    console.error('beforeDestroy')
    window.removeEventListener('click', () => {
      this.hiddenRightMenu()
    })
  },
  methods: {
    async handleTranslate() {
      const msg = JSON.parse(JSON.stringify(this.rightMenu.originalInfo))
      const { data } = await transform(this.rightMenu.msgInfo)
      console.log('翻译', data, this.rightMenu)
      msg.transInfo = data

      this.$store.dispatch('chat/updateMessageFormList', msg)
    },
    handleCopy() {
      console.log('复制')
      if (this.rightMenu?.msgInfo?.text) {
        copyText(this.rightMenu.msgInfo.text)
        this.$message.success(this.$t('复制成功'))
      } else {
        this.$message.error(this.$t('复制失败提示'))
      }
    },
    handleWithdraw() {
      console.log('撤回消息')
      const msgData = JSON.parse(JSON.stringify(this.rightMenu.originalInfo))
      const retractMsgId = this.rightMenu.retractMsgId
      if (retractMsgId) {
        console.log(msgData)
        const that = this
        const oldMsgData = JSON.parse(JSON.stringify(msgData))
        msgData.status = 'recall'
        msgData.msg = '消息已撤回'
        this.$store.dispatch('chat/updateMessageFormList', msgData)
        this.$forceUpdate()
        const option = {
          mid: msgData.id,
          to: msgData.to,
          type: 'chat',
          success() {
            that.$message.success('消息撤回成功')
            console.log('消息撤回成功', msgData)
          },
          fail(e) {
            msgData.status = oldMsgData.status
            msgData.msg = oldMsgData.msg
            that.$message.error('消息撤回失败')
            console.log(e)
          },
        }
        this.$WebIM.conn.recallMessage(option)
      }
    },
    hiddenRightMenu: throttle(
      function () {
        console.log('hiddenRightMenu', this, this.$store)
        this.$store.commit('chat/updateRightMenuStatus', {
          status: 'none',
          left: '0px',
          top: '0px',
          originalInfo: {},
          msgInfo: {},
        })
      },
      1000,
      { leading: true, trailing: true },
    ),
  },
}
</script>
<style lang="scss" scoped>
// 右键菜单样式
.right-menu {
  position: fixed;
  left: 0;
  top: 0;
  min-width: 166px;
  padding-right: 10px;

  height: auto;
  border-radius: 5px;
  background: #fff;
  cursor: pointer;
  border: solid 1px #c2c1c2;
  // box-shadow: 0 10px 10px #C2C1C2;
  z-index: 9999;

  p {
    height: 30px;
    line-height: 30px;
    font-size: 17px;
    font-weight: 500;
    color: #666666;
    text-align: center;

    .icon_translate {
      width: 17px;
      display: inline;
    }

    .icon_translate_hover {
      width: 17px;
      display: none;
    }

    span {
      font-size: 13px;
    }

    &:nth-last-of-type(1) {
      margin-bottom: 0;
    }

    &:hover {
      color: #ff7100;

      .icon_translate {
        display: none;
      }

      .icon_translate_hover {
        display: initial;
      }
    }
  }
}
</style>
